import { FunctionComponent } from 'react';
import Link from 'next/dist/client/link';

import { Props } from './index';
import StyledComponent from './styles';

const PublicLayoutArticleBradCrumb: FunctionComponent<Props> = ({ routes, isSponsored, sponsoredCopy }) => {
    return (
        <StyledComponent className="public-layout-articles-breadcrumbs">
            <ul className="breadcrumbs-list">
                {routes.length > 0  && routes.map(route => (
                    <li
                        key={route.name}
                        className="breadcrumb"
                        style={{ maxWidth: `calc(100% / ${routes.length})` }}
                    >
                        <Link
                            href={route.path}
                            prefetch={false}
                        >
                            <a className="breadcrumb-link">
                                {route.name}
                            </a>
                        </Link>
                    </li>
                ))}
            </ul>
            { isSponsored && sponsoredCopy && (
                <p className="sponsored-article"> {sponsoredCopy} </p>
            )}
        </StyledComponent>
    );
};

export default PublicLayoutArticleBradCrumb;